// MY TASKS SECTION
export const MY_TASKS_BOARDS_FIELDS_TO_SEARCH = [
  'id',
  'board_id',
  'customFields.carId',
  'customFields.subscriptionId',
  'customFields.vehiclePlate',
  'customFields.vehicleModel',
  'customFields.vehicleBrand',
  'customFields.subscriberFirstName',
  'customFields.subscriberLastName',
  'customFields.subscriberEmail',
  'customFields.pipedriveId',
];

export const MY_TASKS_MAILBOX_FIELDS_TO_SEARCH = [
  'to.emailAddress',
  'cc.emailAddress',
  'bcc.emailAddress',
];

// SALES SECTION
export const BOOKINGS_FIELDS_TO_SEARCH = [
  'id',
  'user_id',
  'user_internal_id',
  'first_name',
  'last_name',
  'email',
  'phone_number',
  'vehicle.title',
  'vehicle.id',
  'billingInfo.vat',
];

// SELL VEHICLES SECTION
export const SELL_VEHICLES_FIELDS_TO_SEARCH = [
  'vehicleInternalId',
  'plate',
  'vin',
  'skuId',
  'internalId',
];

export const BUY_OUT_FIELDS_TO_SEARCH = [
  'id',
  'customFields.vehiclePlate',
  'customFields.subscriberEmail',
  'customFields.loanContractId',
];

export const SELL_REQUESTS_FIELDS_TO_SEARCH = [
  'id',
  'customFields.vehiclePlate',
  'customFields.loanContractId',
];

export const DEFLEET_FIELDS_TO_SEARCH = ['subscriptionId', 'carId', 'plate'];

// BILLING SECTION
export const BILLING_TABLE_FIELDS_TO_SEARCH = [
  { label: 'subscriptionId', value: 'customFields.subscriptionId' },
  { label: 'title', value: 'customFields.title' },
  { label: 'carId', value: 'customFields.carId' },
  { label: 'vehiclePlate', value: 'customFields.vehiclePlate' },
  { label: 'id', value: 'id' },
];

// UNIFIED VIEW SECTION
export const UNIFIED_VIEW_MAILBOXES_FIELDS_TO_SEARCH = [
  'to.emailAddress',
  'cc.emailAddress',
  'bcc.emailAddress',
];

export const UNIFIED_VIEW_TEMPLATES_FIELDS_TO_SEARCH = [
  'id',
  'name', // Only name works here
  'createdBy',
];
